import React, { useEffect, useState } from "react";
import { AuthAPI } from "../api/auth";
import { Navigate } from "react-router-dom";
import PreLoader from "./PreLoader";
interface AuthenticatedRouteProps {
  element: React.ReactElement;
  redirectPath?: string;
}
const AuthenticatedRoute = ({
  element,
  redirectPath = "/vips/login",
}: AuthenticatedRouteProps) => {
  const [loading, setLoading] = useState(true);
  const [authenticated, setAuthenticated] = useState(false);

  useEffect(() => {
    const checkAuth = async () => {
      try {
        const res = await AuthAPI.check();
        setAuthenticated(!!res?.id);
      } catch {
        setAuthenticated(false);
      }
      setLoading(false);
    };

    checkAuth();
  }, []);

  if (loading) {
    return (
      // <div className="h-full w-full bg-gray-300/30 flex items-center justify-center backdrop-blur-sm">
      //   <SPINNER />
      // </div>
      <PreLoader />
    );
  }

  if (authenticated) {
    return element;
  } else {
    return <Navigate to={redirectPath} replace />;
  }
};

export default AuthenticatedRoute;
